// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2JlHy","Logo":"SideDrawer_Logo__pOVTu","Open":"SideDrawer_Open__1_YO2","Close":"SideDrawer_Close__317Fq"};